const Loader = () => {
  return (
    <span className="loading loading-spinner text-secondary"></span>
  )
}

export default Loader